(function() {
    'use strict';

    angular.module('file')
        .controller('FileListController', FileListController);

    FileListController.$inject = ['$state', 'fileDataSrvc', 'fileSrvc', 'notificationSrvc', 'fileMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'filePermissionsConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function FileListController($state, fileDataSrvc, fileSrvc, notificationSrvc, fileMessagesConst, lodashService, datatableDefaultPageSizeValueConst, filePermissionsConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.fileRows = [];
        self.fileCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        },
        {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        },
        {
            title: 'Link',
            value: 'file',
            type: 'text',
            searchable: true,
            orderable: false
        }];
        self.modelPermissions = filePermissionsConst;
        self.searchQuery = {
            pk: null,
            name: null,
            file: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getFiles();
        }

        function getFiles(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    file: self.searchQuery.file,
                    ordering: self.searchQuery.ordering
                };
            }
            return fileDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.fileRows = response.results;
                        self.pageOpts.count = response.count;

                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getFiles);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.file.create');
        }

        function onEdit(row) {
            $state.go('layout.file.update', { pk: row.pk });
        }

        function onDelete(row) {
            return fileSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", fileMessagesConst.delete);
                lodashService.remove(self.fileRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getFiles();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getFiles();
        }
    }
})();
